import { lightErrorToast } from "../../Components/customToast";
import requestMethods from "../../helpers/request";

export const shifterTripSeenUpdate = (notificationStatus) => async () => {
  try {
    await requestMethods.PUT({
      endpoint: `v1/shifter/trip/mobile/update-shifter-trip-notification-confirmation-status/${notificationStatus}`,
    });
  } catch (error) {
    lightErrorToast(error.message);
  }
};
